import { render, staticRenderFns } from "./damages.vue?vue&type=template&id=512b7b31&scoped=true"
import script from "./damages.vue?vue&type=script&lang=js"
export * from "./damages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b7b31",
  null
  
)

export default component.exports